module.exports = __webpack_public_path__ + "assets/icons/libs-err.svg?7b15f7";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/icons/libs-err.svg
// module id = 491
// module chunks = 0